<div class="fixed-top">
  <!-- <div id="topbar" class="container form-container">
    <div class="row gx-0 justify-content-between align-items-center">
      <div class="col-sm-4"></div>
    </div>
  </div> -->
  <nav
    class="navbar navbar-expand-lg navbar-light"
    [ngClass]="{ 'sticky-nav': isSticky }"
  >
    <div class="container">
      <a class="navbar-brand p-0" routerLink="./home">
        <img src="/assets/images/shivsa-logo.svg" alt="Logo" class="logo" />
      </a>
      <div class="d-flex align-items-center gap-2">
        <span class="d-lg-none d-md-none d-block">
          <div class="d-flex align-items-center gap-2 justify-content-end">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-language dropdown-toggle btn-sm"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ languageChange.value }}
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li *ngFor="let lang of languageArray">
                  <a class="dropdown-item" (click)="changeLanguage(lang)">
                    <span
                      [ngClass]="{
                        'custom-active': lang === languageChange.value
                      }"
                      >{{ lang }}</span
                    >
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </span>
        <button
          class="btn d-lg-none ms-auto"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#mobileOffcanvas"
          aria-controls="mobileOffcanvas"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <!-- Home -->
          <li
            class="nav-item"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a
              class="nav-link"
              aria-current="page"
              routerLink="/home"
              (click)="closeMobileMenu()"
            >
              {{ "web_header.home" | translate }}
            </a>
          </li>

          <!-- About Us -->
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/about" (click)="closeMobileMenu()">
              {{ "web_header.about_us" | translate }}
            </a>
          </li>

          <!-- Leadership -->
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/leadership"
              (click)="closeMobileMenu()"
            >
              {{ "web_header.leadership" | translate }}
            </a>
          </li>

          <!-- Social Work -->
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              [routerLink]="['/social-work', 1]"
              (click)="closeMobileMenu()"
            >
              {{ "web_header.social_work" | translate }}
            </a>
          </li>

          <!-- Media Dropdown -->
          <li
            class="nav-item dropdown"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="mediaDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ "web_header.media" | translate }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="mediaDropdown">
              <li routerLinkActive="active">
                <a
                  class="dropdown-item"
                  routerLink="/media-gallery"
                  (click)="closeMobileMenu()"
                >
                  {{ "web_header.media_gallery" | translate }}
                </a>
              </li>
              <li routerLinkActive="active">
                <a
                  class="dropdown-item"
                  routerLink="/news-and-event"
                  (click)="closeMobileMenu()"
                >
                  {{ "web_header.news_and_events" | translate }}
                </a>
              </li>
              <li routerLinkActive="active">
                <a class="dropdown-item" (click)="closeMobileMenu()">
                  {{ "web_header.current_affairs" | translate }}
                </a>
              </li>
            </ul>
          </li>

          <!-- Organization -->
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" (click)="closeMobileMenu()">
              {{ "web_header.organization" | translate }}
            </a>
          </li>

          <!-- Suggestions -->
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/suggetions"
              (click)="closeMobileMenu()"
            >
              {{ "web_header.suggestions" | translate }}
            </a>
          </li>

          <!-- Contact Us -->
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="/contact-us"
              (click)="closeMobileMenu()"
            >
              {{ "web_header.contact" | translate }}
            </a>
          </li>

          <!-- Join Us External Link -->
          <li class="nav-item">
            <a
              class="nav-link joinus blink"
              href="https://join.shivsankalp.org/join-us"
              rel="noopener noreferrer"
              target="_blank"
            >
              {{ "web_header.join_us_now" | translate }}
            </a>
          </li>

          <!-- Language Switcher -->
          <li class="d-lg-block d-md-block d-none">
            <div class="d-flex align-items-center gap-2 justify-content-end">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-language dropdown-toggle btn-sm"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ languageChange.value }}
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li *ngFor="let lang of languageArray">
                    <a class="dropdown-item" (click)="changeLanguage(lang)">
                      <span
                        [ngClass]="{
                          'custom-active': lang === languageChange.value
                        }"
                        >{{ lang }}</span
                      >
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div
    class="offcanvas offcanvas-start d-lg-none"
    tabindex="-1"
    id="mobileOffcanvas"
    aria-labelledby="mobileOffcanvasLabel"
  >
    <div class="offcanvas-header">
      <h6 class="offcanvas-title" id="mobileOffcanvasLabel">Shivsankalp</h6>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <!-- Mobile nav content reused -->
      <ul class="navbar-nav">
        <!-- Home -->
        <li
          class="nav-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link" routerLink="/home" (click)="closeMobileMenu()">
            {{ "web_header.home" | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/about" (click)="closeMobileMenu()">
            {{ "web_header.about_us" | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a
            class="nav-link"
            routerLink="/leadership"
            (click)="closeMobileMenu()"
          >
            {{ "web_header.leadership" | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a
            class="nav-link"
            [routerLink]="['/social-work', 1]"
            (click)="closeMobileMenu()"
          >
            {{ "web_header.social_work" | translate }}
          </a>
        </li>
        <li
          class="nav-item dropdown"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <a
            class="nav-link dropdown-toggle"
            href="#"
            data-bs-toggle="dropdown"
          >
            {{ "web_header.media" | translate }}
          </a>
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item"
                routerLink="/media-gallery"
                (click)="closeMobileMenu()"
              >
                {{ "web_header.media_gallery" | translate }}
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="/news-and-event"
                (click)="closeMobileMenu()"
              >
                {{ "web_header.news_and_events" | translate }}
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink=""
                (click)="closeMobileMenu()"
              >
                {{ "web_header.current_affairs" | translate }}
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" rou (click)="closeMobileMenu()">
            {{ "web_header.organization" | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a
            class="nav-link"
            routerLink="/suggetions"
            (click)="closeMobileMenu()"
          >
            {{ "web_header.suggestions" | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a
            class="nav-link"
            routerLink="/contact-us"
            (click)="closeMobileMenu()"
          >
            {{ "web_header.contact" | translate }}
          </a>
        </li>
        <li class="nav-item blink">
          <a
            class="nav-link joinus"
            href="https://join.shivsankalp.org/join-us"
            target="_blank"
          >
            {{ "web_header.join_us_now" | translate }}
          </a>
        </li>

        <!-- Language switcher (for mobile) -->
        <li class="nav-item mt-3">
          <div class="btn-group w-100">
            <button
              type="button"
              class="btn btn-language dropdown-toggle w-100"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ languageChange.value }}
            </button>
            <ul class="dropdown-menu w-100">
              <li *ngFor="let lang of languageArray">
                <a class="dropdown-item" (click)="changeLanguage(lang)">
                  <span
                    [ngClass]="{
                      'custom-active': lang === languageChange.value
                    }"
                    >{{ lang }}</span
                  >
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
